import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { CvcTagGroupComponent } from './tag-group.component'

@NgModule({
  declarations: [CvcTagGroupComponent],
  imports: [CommonModule],
  exports: [CvcTagGroupComponent],
})
export class CvcTagGroupModule {}
